// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundles_bundles__6Smp9","bundleDetail":"Bundles_bundleDetail__Of8H1","shoppingBox":"Bundles_shoppingBox__6iakN","installation":"Bundles_installation__kyprC"};